import { useGetBakeryRecordsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { bakeryRecordsColumns, type BakeryRecordRow } from '../constants/bakeryRecordsColumns';

export const BakeryRecordsList = () => {
    const {
        loading: bakeryRecordsLoading,
        data: bakeryRecordsData,
        error: bakeryRecordsError,
    } = useGetBakeryRecordsQuery();

    if (bakeryRecordsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!bakeryRecordsData || bakeryRecordsError) {
        throw new Error('Une erreur est survenue lors de la r\u00e9cup\u00e9ration des bakeryRecords');
    }

    const { bakeryRecords } = bakeryRecordsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<BakeryRecordRow>
                columns={bakeryRecordsColumns}
                data={bakeryRecords}
                filterMode="client"
                getRowId={(row) => row._id}
            />
        </div>
    );
};
